
// Here You can type your custom JavaScript...
var validateForm;

(function($) {
    validateForm = function() {

        $(document).on('focusout keyup', 'input[type="text"], input[type="number"]', function() {
            var input = $(this);

            if(input.closest('.required').length) {
                if($.trim(input.val()).length) {
                    input.removeClass('error');
                } else {
                    input.addClass('error');
                }
            }

            if(isEmail(input)) {

                if(input.hasClass('error')) {
                    input.removeClass('error');
                }
            } else {

                input.addClass('error');
            }
        });

        $(document).on('focusout keyup mouseup', 'input[type="radio"]', function() {
            var input = $(this);

            if(input.closest('.required').length) {
                var group = $('input[name="' + $(this).attr('name') + '"]');
                if(typeof $('input[name="' + $(this).attr('name') + '"]:checked').val() == "undefined") {
                    group.addClass('error');
                } else {
                    group.removeClass('error');
                }
            }
        });

        $(document).on('submit', 'form', function(e) {
            var form = $(this);
            var event = e;

            if(form.find('.required').length) {
                form.find('.required').each(function() {
                    var requiredField = $(this);

                    requiredField.find('input[type="text"], input[type="number"]').each(function() {
                        if($.trim($(this).val()).length <= 0) {
                            $(this).addClass('error');
                            event.preventDefault();
                        }
                    });

                    requiredField.find('input[type="radio"]').each(function() {
                        if(typeof $('input[name="' + $(this).attr('name') + '"]:checked').val() == "undefined") {
                            $(this).addClass('error');
                            event.preventDefault();
                        }
                    });
                });
            }
        });

        isNumeric = function(input) {
            if(input.closest('.is-numeric').length) {
                return $.isNumeric(input);
            }

            return true;
        };

        notNumeric = function(input) {
            if(input.closest('.not-numeric').length) {
                return !$.isNumeric(input);
            }

            return true;
        };

        isEmail = function(input) {
            if(input.closest('.is-email').length) {

                var pattern = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+.[A-Za-z]{2,4}$/;
                var res=pattern.test(input.val());
                return res;
            }

            return true;
        };
    };
})(jQuery);
